import { Routes, Route } from "react-router-dom";
import Home from "./App";  // Your main homepage
import Membership from "./Membership";  // Membership page
import Blog from "./Blog";
//import { Routes, Route } from "react-router-dom";
import BlogPage from "./BlogPage";
//import Membership from "./Membership";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/" element={<Blog />} />
      <Route path="/blog/:id" element={<BlogPage />} />
      <Route path="/membership" element={<Membership />}/>
    </Routes>
  );
}

export default App;
